import { Component, OnInit } from '@angular/core';
import { MatDialogConfig, MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { MaintenanceService } from '../../../shared/services/maintenance.service';
import { CommonModelService } from '../../../padu-reporting/capability/common-model.service';
import { ToastrService } from 'ngx-toastr';
import { DailogModalComponent } from '../../../shared/elements/dailog-modal/dailog-modal.component';
import { Router } from '@angular/router';
import { environment } from '../../../../environments/environment';
import { SharedService, ExportDataService } from '../../../shared';
import { SharedAuthService } from '../../../shared/shared.auth.service';
import { take } from 'rxjs/operators';
@Component({
    selector: 'app-org-maintenance-v4',
    templateUrl: './org-maintenance-v4.component.html',
    styleUrls: ['./org-maintenance-v4.component.css'],
    standalone: false
})
export class OrgMaintenanceV4Component implements OnInit {
  userAccessData: any;

  constructor(
    public maintenanceService: MaintenanceService,
    private router: Router,
    private modelService: CommonModelService,
    public dialog: MatDialog,
    private toaster: ToastrService,
    private sharedService: SharedService,
    public exportService: ExportDataService,
    private sharedAuthService : SharedAuthService
  ) {}
  public showLoader: boolean = false;
  TABLE_CONFIG: any = {
    pageSize: [10, 20, 40],
    pageIndex: 0,
    totalItems: 0,
    selection: false,
    edit: false,
    serverSidePagination: false,
    deleteFeature: true,
    expandable: false
  };
  searchField: any;
  TABLE_COLUMNS: any = [
    {
      key: 'org_id',
      labelKey: 'org_id',
      label: 'Organization ID',
      addNew: false,
      filter: false,
      search: '',
      searchValue: '',
      edit: true,
      validations: [{ required: false }]
    },
    {
      key: 'org_name',
      labelKey: 'org_name',
      label: 'Organization',
      addNew: false,
      filter: false,
      search: '',
      searchValue: '',
      edit: true,
      validations: [{ required: true }]
    }
  ];

  EditAction = {
    key: 'isEdit',
    label: 'Action',
    align: 'center'
  };

  data = [];

  DATA_SCHEMA = {
    org_name: 'text',
    isEdit: 'isEdit'
  };
  sortConfig = {
    active: 'Full_Name',
    direction: 'asc'
  };

  dataSourceDetails: MatTableDataSource<any>;
  selectedRow: any = {};
  editModelView: boolean = environment.isAdminRole;
  sort: any;
  ngOnInit() {
    if (!sessionStorage.getItem('techaccessData')) {
      this.sharedAuthService.userAccessDataSource.pipe(take(1)).subscribe(accessData => {
        this.getOrgList();
      });
    } else {
        this.getOrgList();
    }
  }

  getOrgList = async () => {
    this.showLoader = true;
    await this.getOrganizationList();
    this.userAccessData = this.sharedAuthService.getTechAccessData();
    let userAccessRoleFromTechAccessTbl = 'none';
    if (this.userAccessData) userAccessRoleFromTechAccessTbl = this.userAccessData.Role;
    const isAdminRole = this.sharedAuthService.checkAdminSGAccess();
    const isAdmin = (isAdminRole && userAccessRoleFromTechAccessTbl.toLowerCase() == 'admin').toString();
    if (isAdmin == 'true') {
      this.TABLE_COLUMNS.push(this.EditAction);
      this.TABLE_CONFIG['edit'] = true;
    }
    this.showLoader = false;
  };

  getOrganizationList() {
    return new Promise((resolve, reject) => {
      this.maintenanceService.getOrganizationList().subscribe(
        (d: any) => {
          if (d && d.length) {
            this.dataSourceDetails = new MatTableDataSource(d);
            this.TABLE_CONFIG['TABLE_CLASS'] = 'org-maintenance-tble-container';
            this.TABLE_CONFIG.totalItems = d.length;
            resolve(true);
          } else {
            reject('org-maintenance-tble-container not loaded');
          }
        },
        error => {
          console.error(error);
          this.TABLE_CONFIG.totalItems = 0;
          resolve(true);
        }
      );
    });
  }

  AddNewEntry() {
    const keysList = Object.keys(this.DATA_SCHEMA);
    const newRecord: any = {};
    keysList.forEach(ele => {
      newRecord[ele] = '';
    });
    newRecord['isEdit'] = true;
    newRecord['isNew'] = true;
    this.searchField = '';
    this.modelService.setAddCapability(newRecord);
  }

  searchDataSet(event) {
    const filterValue = event ? (event.target as HTMLInputElement).value : '';
    this.dataSourceDetails.filter = filterValue.trim().toLowerCase();
  }
  cancelEvent() {
    this.maintenanceService.getOrgListSubjectValues().subscribe(
      (d: any) => {
        if (d && d.length) {
          this.dataSourceDetails = new MatTableDataSource(d);
          this.TABLE_CONFIG['TABLE_CLASS'] = 'org-maintenance-tble-container';
          this.TABLE_CONFIG.totalItems = d.length;
        } else {
          this.TABLE_CONFIG.totalItems = 0;
        }
      },
      () => {
        this.toaster.error('Something went wrong, Please try again later', '', {
          timeOut: 10000,
          positionClass: 'toast-top-center'
        });
      }
    );
  }

  async saveEvent(e) {
    if (e.org_name && !e.org_name.trim().length) {
      this.toaster.error('Please enter valid organization name', '', {
        timeOut: 10000,
        positionClass: 'toast-top-center'
      });
      this.showLoader = true;
      this.getOrganizationList()
        .then(data => {
          if (data) {
            this.showLoader = false;
          }
        })
        .catch(err => {
          this.showLoader = false;
          console.log(err);
        });
    } else {
      if (e['isNew']) {
        const payload = {
          org_name: e.org_name && e.org_name.trim(),
          createdById: this.sharedAuthService.getMsid(),
          createdByName: JSON.parse(sessionStorage.getItem('currentUser'))
        };
        this.showLoader = true;
        this.maintenanceService.addNewOrganization(payload).subscribe({
          next: async data => {
            if (data) {
              this.showLoader = false;
              await this.getOrganizationList();
              this.searchField = '';
              this.toaster.success('Successfully added', '', { timeOut: 10000, positionClass: 'toast-top-center' });
            }
          },
          error: async error => {
            console.log(error, 'error occured while update');
            this.showLoader = false;
            await this.getOrganizationList();
            if (error.error.status !== 400) {
              if (error.error.errors) {
                this.toaster.error(error.error.errors, '', { timeOut: 10000, positionClass: 'toast-top-center' });
              } else if(error.error.message) {
                this.toaster.error(error.error.message, '', {
                  timeOut: 10000,
                  positionClass: 'toast-top-center'
                });
              } else{
                this.toaster.error('Something went wrong, Please try again later', '', {
                  timeOut: 10000,
                  positionClass: 'toast-top-center'
                });
              }
            } else {
              this.toaster.error('Something went wrong, Please try again later', '', {
                timeOut: 10000,
                positionClass: 'toast-top-center'
              });
            }
          }
        });
      } else {
        const payload = {
          org_name: e.org_name && e.org_name.trim(),
          updatedById: this.sharedAuthService.getMsid(),
          updatedByName: JSON.parse(sessionStorage.getItem('currentUser'))
        };
        this.showLoader = true;
        this.maintenanceService.editExistingOrganization(e.org_id, payload).subscribe({
          next: async data => {
            if (data) {
              this.showLoader = false;
              await this.getOrganizationList();
              this.searchField = '';
              this.toaster.success('Successfully updated', '', { timeOut: 10000, positionClass: 'toast-top-center' });
            }
          },
          error: async error => {
            console.log(error, 'error occured while update');
            this.showLoader = false;
            await this.getOrganizationList();
            this.toaster.error('Something went wrong, Please try again later', '', {
              timeOut: 10000,
              positionClass: 'toast-top-center'
            });
            if (error.error.status !== 400) {
              if (error.error.errors) {
                this.toaster.error(error.error.errors, '', { timeOut: 10000, positionClass: 'toast-top-center' });
              }
            }
          }
        });
      }
    }
  }

  /**
   *
   * @param event
   */

  tablePaginationEvent(event) {
    if (event) {
      if (event.sort) {
        this.sort = event.sort;
      }
      this.TABLE_CONFIG['pageSize'] = event.pageSize;
      this.TABLE_CONFIG['pageIndex'] = event.pageIndex;
      this.getOrgList();
    }
  }

  checkBoxEvent(e) {
    this.selectedRow = e;
  }

  deleteOrganization(event) {
    const id = event.org_id;
    if (!id) {
      alert('Organization id not found');
      return;
    } else {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.width = '400px';
      dialogConfig.hasBackdrop = true;
      dialogConfig.minHeight = '200px';
      dialogConfig.height = 'auto';
      dialogConfig.disableClose = true;
      dialogConfig.autoFocus = false;
      dialogConfig.data = {
        title: 'Delete Organization Confirmation!',
        subTitle: `${[event].length} selected organization will be deleted. Click delete to proceed..`,
        buttonName: 'Delete'
      };

      const dialogRef = this.dialog.open(DailogModalComponent, dialogConfig);
      dialogRef.afterClosed().subscribe(result => {
        
        if (result.data === 'save') {
          const payload = {
            updatedById: this.sharedAuthService.getMsid(),
            updatedByName: JSON.parse(sessionStorage.getItem('currentUser'))
          };
          this.showLoader = true;
          this.maintenanceService.deleteOrganization(payload, id).subscribe(
            async res => {
              if (res) {
                this.toaster.success('Successfully deleted.', '', {
                  timeOut: 10000,
                  positionClass: 'toast-top-center'
                });
                this.searchField = '';
                this.showLoader = false;
                await this.getOrganizationList();
              }
            },
            async err => {
              this.showLoader = false;
              await this.getOrganizationList();
              if(err.error.errors)
              this.toaster.error(err.error.errors, '', { timeOut: 10000, positionClass: 'toast-top-center' });
              else
              this.toaster.error(err.error.message, '', { timeOut: 10000, positionClass: 'toast-top-center' });

            }
          );
        }
      });
    }
  }

  navigateHomePage() {
    this.router.navigate([{ outlets: { primary: 'landing-page' } }]);
  }

  exportToExcel() {
    const exportData = [];
    this.dataSourceDetails.data.forEach(element => {
      const exportJSON: any = {};

      exportJSON['Organization ID'] = element.org_id;
      exportJSON['Organization Name'] = element.org_name;
      exportData.push(exportJSON);
    });
    this.exportService.exportToExcel('Organization', [exportData]);
  }
}
